var exports = {
  "Mv": "TextareaButtons.module__invisibleTrigger___VXhwOW",
  "IO": "TextareaButtons.module__mobileRightButtonContainer___VXhwOW",
  "Pc": "TextareaButtons.module__mobileRightButtonSlot___VXhwOW",
};

module.exports = exports;
